import React from 'react';
import UsersComponent from '../components/UsersComponent';
import { NETWORKING_CATEGORIES } from '../utils/categories';

export default function UsersPage() {
  const [UsersData, setUsersData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);


  const categorias = NETWORKING_CATEGORIES;

  React.useEffect(() => {
    const fetchUsers = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        alert('No estás autenticado. Por favor, inicia sesión.');
        window.location.href = '/';
        return;
      }

      try {
        setLoading(true);
        const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:3005'}/users/`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        const data = await response.json();

        if (!response.ok) {
          alert(data.message || 'Error al obtener los usuarios');
          window.location.href = '/';
          return;
        }

        setUsersData(data);
      } catch (error) {
        console.error('Error fetching Users:', error);
        alert('Error al obtener los proyectos');
      }
      finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, []);

  return <UsersComponent Users={UsersData} categorias={categorias} loading={loading} />;
}
